import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

import ComparatorFilterSelect from './comparator_filters/Select'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getItalianRegionMenuItems } from '../../../libs/ItalianRegions'
import { getCountrySourceMenuItems } from './../../../libs/CountrySources'

import './ComparatorFilters.css'

/*
const styles = theme => ({
    title: {
        color: theme.palette.text.primary
    },
    bigSelect: {
        ...theme.typography.display2,
        color: theme.palette.text.primary
    },
    bigSelectSelectMenu: {
        whiteSpace: 'unset'
    }
  });
*/

const styles = theme => ({
    root: {
      flexGrow: 1,
    }
})

class ComparatorFilters extends Component {

    /* Methods */

    handleRegionChange = (event) => {
        this.props.onRegionChange(event.target.value)
    }

    handleDataTypeChange = (event) => {
        this.props.onDataTypeChange(event.target.value)
    }

    handleSourceChange = (event) => {
        this.props.onSourceChange(event.target.value)
    }

    /* Lifecycle */
     
    render() {
        const { onRegionChange, regionValue } = this.props
        const { onDataTypeChange, dataTypeValue, dataTypes } = this.props
        const { onSourceChange, sourceValue } = this.props
        const { onAddComparator, onRemoveComparator } = this.props
        const { classes } = this.props

        const addComparatorButton = (
            <Button variant="contained" color="primary" fullWidth={true} onClick={onAddComparator}>
                Confronta con
            </Button>
        )

        const removeComparatorButton = (
            <Button variant="contained" color="secondary" fullWidth={true} onClick={onRemoveComparator}>
                Rimuovi confronto
            </Button>
        )
        
        const withSources = onSourceChange && sourceValue
        const smSize = withSources ? 3 : 4

        const comparatorRow = (
            <div className={classes.root}>
                <Grid container spacing={8} alignItems="flex-end">
                    <Grid item xs={12} sm={smSize}>
                        <ComparatorFilterSelect
                            inputLabel="Regione"
                            name="region"
                            value={regionValue}
                            menuItems={getItalianRegionMenuItems(this.context.t)}
                            onChange={this.handleRegionChange}/>
                    </Grid>
                    <Grid item xs={12} sm={smSize}>
                        <ComparatorFilterSelect
                            inputLabel="Dati"
                            name="data_types"
                            value={dataTypeValue}
                            menuItems={dataTypes}
                            onChange={this.handleDataTypeChange}/>
                    </Grid>
                    {
                        withSources
                            ? (
                                <Grid item xs={12} sm={smSize}>
                                    <ComparatorFilterSelect
                                        inputLabel="Provenienza"
                                        name="source"
                                        value={sourceValue}
                                        menuItems={getCountrySourceMenuItems(this.context.t)}
                                        onChange={this.handleSourceChange}/>
                                </Grid>
                            )
                            : null
                    }
                    <Grid item xs={12} sm={smSize}>
                        { onAddComparator ? addComparatorButton : null }
                        { onRemoveComparator ? removeComparatorButton : null }
                    </Grid>
                </Grid>
            </div>
        )

        return (
            <div className="pages-shared-comparator-filters">
                <form autoComplete="off">
                    {comparatorRow}
                </form>
            </div>       
        )
    }
}

ComparatorFilters.contextTypes = {
    t: PropTypes.func
}

const styledComparatorFilters = withStyles(styles)(ComparatorFilters)

export default styledComparatorFilters

/*
const mapStateToProps = state => ({
    pathname: state.router.location.pathname
})

function mapDispatchToProps(dispatch) {
    return { 
        actions: {
            pushToUrl: bindActionCreators(push, dispatch)
        }
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)()
*/


// WEBPACK FOOTER //
// ./src/components/pages/shared/ComparatorFilters.js